/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goal_Hard_TInputs */

const en_funnel_ob_goal_hard_t = /** @type {(inputs: Funnel_Ob_Goal_Hard_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading is hard for me`)
};

const es_funnel_ob_goal_hard_t = /** @type {(inputs: Funnel_Ob_Goal_Hard_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer me cuesta`)
};

/**
* | output |
* | --- |
* | "Reading is hard for me" |
*
* @param {Funnel_Ob_Goal_Hard_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goal_hard_t = /** @type {((inputs?: Funnel_Ob_Goal_Hard_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goal_Hard_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goal_hard_t(inputs)
	return en_funnel_ob_goal_hard_t(inputs)
});